package com.wintermar.inspection.core.ui.widget

import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import kotlin.math.floor

@Composable
fun HorizontalProgress(
    progress: Int,
    total: Int,
    modifier: Modifier = Modifier,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    val totalCount by remember(total) {
        derivedStateOf { total }
    }

    val targetProgress by remember(totalCount, progress) {
        derivedStateOf {
            val progressValue = (if (progress > totalCount) totalCount else progress).toFloat()
            if (totalCount == 0) 0f else progressValue / totalCount
        }
    }

    val animatedProgress by animateFloatAsState(
        targetValue = targetProgress,
        animationSpec = tween(durationMillis = 450)
    )

    val answeredPercent = floor(animatedProgress * 100).toInt()

    LinearProgressIndicator(
        progress = { animatedProgress },
        modifier = modifier.fillMaxHeight().animateContentSize(),
        trackColor = color.surface.neutral.subtle.default,
        gapSize = dimension.spacing.space0,
        drawStopIndicator = {
            // no-op
        }
    )
}
